import { ChangeDetectorRef, Component, OnDestroy } from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatInputModule } from '@angular/material/input';
import { CommonModule, DatePipe, formatDate, Location } from '@angular/common';
import { MatChipsModule } from '@angular/material/chips';
import { ReactiveFormsModule, FormsModule, FormGroup, FormBuilder, FormArray, Validators } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatRadioModule } from '@angular/material/radio';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { APIService } from '../../backend-service/backend-service';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { SharedService } from '../../../share-data/shared.service';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule, DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatMomentDateModule, MomentDateAdapter } from '@angular/material-moment-adapter';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { NotificationService } from '../../../shared/services/notification.service';
import { LoadingService } from '../../../services/loading.service';
import { Subscription } from 'rxjs';
import { PhoneFormatDirective } from '../../../shared/directives/phone-format.directive';
import { environment } from '../../../../environments/environment';

export const DATE_FORMATS = {
  display: {
    dateInput: 'DD-MM-yyyy', // Format used in the input field
    monthYearLabel: 'MMM yyyy', // Month-year format in the calendar view
    dateA11yLabel: 'LL', // Accessibility label
    monthYearA11yLabel: 'MMMM yyyy' // Accessibility label for month-year
  }
};
@Component({
  selector: 'app-driver-registration',
  imports: [
    ReactiveFormsModule,
    FormsModule,
    MatCheckboxModule,
    MatInputModule,
    CommonModule,
    MatChipsModule,
    MatSelectModule,
    MatFormFieldModule,
    MatAutocompleteModule,
    MatIconModule,
    MatRadioModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatMomentDateModule,
    MatProgressSpinnerModule,
    PhoneFormatDirective
  ],
  providers: [
    DatePipe,
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' }, // British locale to ensure dd/mm/yyyy format
    { provide: MAT_DATE_FORMATS, useValue: DATE_FORMATS } // Provide the custom formats
  ],
  templateUrl: './driver-registration.component.html',
  styleUrl: './driver-registration.component.scss'
})
export class DriverRegistrationComponent implements OnDestroy {
  khmerName: string = '';
  englishName: string = '';
  dateOfBirth: string = '';
  joinDate: string = '';
  age: number | null = null;
  NIDNumber: string = '';
  NIDExpiredDate: string = '';
  driverLicenseNumber: string = '';
  driverLicenseExpireDate: string = '';
  currentAddress: string = '';
  emergencyContactNumber: string = '';
  selectedFiles: File[] = [];
  driverPicture!: File;
  nidPicture!: File;
  driveLicensePicture!: File;
  criminalRecordPicture!: File;
  supportDocFiles: File[] = [];
  lightboxFile: File | null = null;
  lightboxUrl: SafeResourceUrl | null = null;
  genderOption: string[] = ['Male', 'Female'];
  selectedGender: string = this.genderOption[0];
  maritalStautsOption: string[] = ['Single', 'Married'];
  selectedMaritalStatus: string = this.maritalStautsOption[0];
  contactNumber: string[] = [];

  // Cached image URLs to prevent NG0100 error
  private imageUrlCache = new Map<File, string>();
  emergencyContact: string = '';
  phoneForm!: FormGroup;
  primaryContact: string = '';
  secondaryContact: string[] = [];
  isEdit: string = '';
  editData: any;
  isLoading: boolean = false;
  private loadingSubscription: Subscription;


  constructor(private fb: FormBuilder, private cdr: ChangeDetectorRef, private apiService: APIService,
    private router: Router, private http: HttpClient, private route: ActivatedRoute, private sharedService: SharedService,
    public location: Location, private datePipe: DatePipe, private sanitizer: DomSanitizer,
    private notification: NotificationService, public loadingService: LoadingService) {
    this.loadingSubscription = this.loadingService.isLoading$.subscribe(loading => this.isLoading = loading);
    this.phoneForm = this.fb.group({
      phoneNumbers: this.fb.array([this.createPhoneNumberField()]), // Start with one field
    });
  }

  get phoneNumbers(): FormArray {
    return this.phoneForm.get('phoneNumbers') as FormArray;
  }

  ngOnInit() {

    this.route.queryParams.subscribe(async params => {
      this.isEdit = params["isEdit"];
      if (this.isEdit == 'true') {
        try {
          this.editData = this.sharedService.getData();
          // this.loadEditData(this.editData);
          console.log("Share data:", this.editData);

          // Map basic fields
          this.khmerName = this.editData["khmerName"] || '';
          this.englishName = this.editData["englishName"] || '';
          this.NIDNumber = this.editData["nidNumber"] || '';
          // this.NIDExpiredDate = this.editData["nidExpiryDate"] || '';
          this.driverLicenseNumber = this.editData["driverLicenseNumber"] || '';
          // this.driverLicenseExpireDate = this.editData["driverLicenseExpiryDate"] || '';
          this.currentAddress = this.editData["currentAddress"] || '';
          this.primaryContact = this.editData["primaryContactNumber"] || '';
          this.secondaryContact = this.editData["secondaryContactNumber"] ? this.editData["secondaryContactNumber"].split(',') : [];
          this.emergencyContactNumber = this.editData["emergencyContactNumber"] || '';
          this.selectedGender = this.editData["gender"] || this.genderOption[0];
          this.selectedMaritalStatus = this.editData["maritalStatus"] || this.maritalStautsOption[0];
          this.phoneNumbers.clear();

          // Add primary contact
          if (this.primaryContact && this.primaryContact.length > 7) {
            this.phoneNumbers.push(this.fb.group({
              number: [this.primaryContact, [Validators.required, Validators.pattern(/^\d+$/)]]
            }));
          }
          for (const phone of this.secondaryContact) {
            if (phone.length > 7) {
              this.phoneNumbers.push(this.fb.group({
                number: [phone.trim(), [Validators.required, Validators.pattern(/^\d+$/)]]
              }));
            }
          }

          const driverPicURL = this.editData["driverPicURL"];
          const driverName = this.editData["picture"];
          const driverFile = await this.fetchImageAsFile(driverPicURL, driverName);
          this.driverPicture = driverFile;

          const nidPicURL = this.editData["nidPicURL"];
          const nidName = this.editData["nidPicture"];
          const nidFile = await this.fetchImageAsFile(nidPicURL, nidName);
          this.nidPicture = nidFile;

          const driverLicenseURL = this.editData["driverLicenseURL"];
          const driverLicenseName = this.editData["driverLicensePicture"];
          const driverLicenseFile = await this.fetchImageAsFile(driverLicenseURL, driverLicenseName);
          this.driveLicensePicture = driverLicenseFile;

          const supportedDocuments: string[] = this.editData["supportedDocuments"]?.length
            ? this.editData["supportedDocuments"]
            : this.editData["criminalRecordDocument"]
              ? [this.editData["criminalRecordDocument"]]
              : [];
          const supportedDocumentFiles = await Promise.all(
            supportedDocuments.map((path: string) => this.fetchImageAsFile(environment.imageUrl + path, path.split('/').pop() || 'document'))
          );
          this.criminalRecordPicture = supportedDocumentFiles[0];
          this.supportDocFiles = supportedDocumentFiles;

          if (this.editData["nidExpiryDate"]) {
            const date = new Date(this.editData["nidExpiryDate"]);
            this.NIDExpiredDate = this.datePipe.transform(date, 'yyyy-MM-dd') || '';
          }

          if (this.editData["driverLicenseExpiryDate"]) {
            const date = new Date(this.editData["driverLicenseExpiryDate"]);
            this.driverLicenseExpireDate = this.datePipe.transform(date, 'yyyy-MM-dd') || '';
          }

          if (this.editData["dateOfBirth"]) {
            const date = new Date(this.editData["dateOfBirth"]);
            this.dateOfBirth = this.datePipe.transform(date, 'yyyy-MM-dd') || '';
            this.calculateAge(date);
          }

          if (this.editData["joinDate"]) {
            const date = new Date(this.editData["joinDate"]);
            this.joinDate = this.datePipe.transform(date, 'yyyy-MM-dd') || '';
          }

          this.cdr.detectChanges(); // Ensure changes are reflected
        } catch (error) {
          console.error('Error mapping user data:', error);
        }
      } else {
      }
    });
  }
  async fetchImageAsFile(url: string, filename: string): Promise<File> {
    const response = await fetch(url);
    const blob = await response.blob();
    const mime = blob.type || 'image/jpeg';

    return new File([blob], filename, { type: mime });
  }

  // Maximum file size in bytes (500KB)
  private readonly MAX_FILE_SIZE = 500 * 1024;

  // Compress image to reduce file size (max 500KB)
  async compressImage(file: File): Promise<File> {
    // Skip compression for non-image files
    if (!file.type.startsWith('image/')) {
      return file;
    }

    // If file is already under the limit, return as-is
    if (file.size <= this.MAX_FILE_SIZE) {
      console.log(`${file.name} is already under 500KB (${(file.size / 1024).toFixed(2)}KB)`);
      return file;
    }

    // Try progressively lower quality until under 500KB
    let quality = 0.8;
    let maxWidth = 1200;
    let compressedFile = file;

    while (compressedFile.size > this.MAX_FILE_SIZE && quality > 0.1) {
      compressedFile = await this.compressWithSettings(file, maxWidth, quality);

      if (compressedFile.size > this.MAX_FILE_SIZE) {
        quality -= 0.1;
        if (quality <= 0.3 && maxWidth > 600) {
          maxWidth -= 200;
          quality = 0.6;
        }
      }
    }

    console.log(`Compressed ${file.name}: ${(file.size / 1024).toFixed(2)}KB -> ${(compressedFile.size / 1024).toFixed(2)}KB`);
    return compressedFile;
  }

  // Helper method to compress with specific settings
  private compressWithSettings(file: File, maxWidth: number, quality: number): Promise<File> {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = (event) => {
        const img = new Image();
        img.onload = () => {
          const canvas = document.createElement('canvas');
          let width = img.width;
          let height = img.height;

          // Scale down if width exceeds maxWidth
          if (width > maxWidth) {
            height = (height * maxWidth) / width;
            width = maxWidth;
          }

          canvas.width = width;
          canvas.height = height;

          const ctx = canvas.getContext('2d');
          if (!ctx) {
            resolve(file);
            return;
          }

          ctx.drawImage(img, 0, 0, width, height);

          canvas.toBlob(
            (blob) => {
              if (blob) {
                const compressedFile = new File([blob], file.name, {
                  type: 'image/jpeg',
                  lastModified: Date.now(),
                });
                resolve(compressedFile);
              } else {
                resolve(file);
              }
            },
            'image/jpeg',
            quality
          );
        };
        img.onerror = () => resolve(file);
        img.src = event.target?.result as string;
      };
      reader.onerror = () => resolve(file);
      reader.readAsDataURL(file);
    });
  }

  calculateAge(date: Date): void {
    const today = new Date();
    let age = today.getFullYear() - date.getFullYear();
    const monthDiff = today.getMonth() - date.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < date.getDate())) {
      age--;
    }
    this.age = age >= 0 ? age : null;
  }

  onDobChange(event: any): void {
    const date = event.value ? new Date(event.value) : null;
    if (date) {
      this.calculateAge(date);
    } else {
      this.age = null;
    }
  }

  createPhoneNumberField(): FormGroup {
    return this.fb.group({
      number: ['', [Validators.required, Validators.pattern(/^\d+$/)]], // Only numbers allowed
    });
  }

  addPhoneNumber(): void {
    this.phoneNumbers.push(this.createPhoneNumberField());
    this.cdr.detectChanges();
  }

  removePhoneNumber(index: number): void {
    if (this.phoneNumbers.length > 1) {
      this.phoneNumbers.removeAt(index);
    }
  }

  async onSelecteDriverPicFile(event: Event): Promise<void> {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files[0]) {
      this.driverPicture = await this.compressImage(input.files[0]);
    }
  }
  async onSelecteNIDPicFile(event: Event): Promise<void> {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files[0]) {
      this.nidPicture = await this.compressImage(input.files[0]);
    }
  }
  async onSelectedDriverLicenseFile(event: Event): Promise<void> {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files[0]) {
      this.driveLicensePicture = await this.compressImage(input.files[0]);
    }
  }
  async onSelectedCriminalRecordFile(event: Event): Promise<void> {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files[0]) {
      this.criminalRecordPicture = await this.compressImage(input.files[0]);
    }
  }

  async onSelectedSupportDocFiles(event: Event): Promise<void> {
    const input = event.target as HTMLInputElement;
    if (input.files) {
      const newFiles = Array.from(input.files);
      const processed = await Promise.all(newFiles.map(f => this.compressImage(f)));
      this.supportDocFiles = [...this.supportDocFiles, ...processed];
      input.value = '';
    }
  }

  removeSupportDoc(index: number): void {
    const file = this.supportDocFiles[index];
    if (this.imageUrlCache.has(file)) {
      URL.revokeObjectURL(this.imageUrlCache.get(file)!);
      this.imageUrlCache.delete(file);
    }
    this.supportDocFiles = this.supportDocFiles.filter((_, i) => i !== index);
  }

  isPdf(file: File): boolean {
    return file.type === 'application/pdf' || file.name.toLowerCase().endsWith('.pdf');
  }

  viewDocument(file: File): void {
    if (this.isPdf(file)) {
      const url = URL.createObjectURL(file);
      this.lightboxUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    } else {
      this.lightboxUrl = null;
    }
    this.lightboxFile = file;
  }

  closeLightbox(): void {
    this.lightboxFile = null;
    this.lightboxUrl = null;
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files) {
      this.selectedFiles = Array.from(input.files);
    }
  }
  getImageUrl(file: File): string {
    if (!file) return '';

    // Check if URL is already cached
    if (this.imageUrlCache.has(file)) {
      return this.imageUrlCache.get(file)!;
    }

    // Create and cache the URL
    const url = URL.createObjectURL(file);
    this.imageUrlCache.set(file, url);
    return url;
  }

  submitButtonAction() {
    this.secondaryContact = [];
    const phoneNumbersArray = this.phoneNumbers.controls.map(group => group.get('number')?.value);
    if (phoneNumbersArray.length > 0) {
      this.primaryContact = phoneNumbersArray[0];
      if (phoneNumbersArray.length > 1) {
        let index = 0;
        phoneNumbersArray.forEach(phone => {
          if (index > 0) {
            this.secondaryContact.push(phone)
          }
          index++;
        });
      }
    }
    if (this.khmerName.length < 1) {
      this.notification.warning('Please enter Khmer name')
      return;
    }
    if (this.englishName.length < 1) {
      this.notification.warning('Please enter English name')
      return;
    }
    if (this.NIDNumber == null) {
      this.notification.warning('Please enter NID number')
      return;
    }
    if (this.NIDExpiredDate.length < 1) {
      this.notification.warning('Please enter NID expired date')
      return;
    }
    if (this.driverLicenseNumber.length < 1) {
      this.notification.warning('Please enter Driver License Number')
      return;
    }
    if (this.driverLicenseExpireDate.length < 1) {
      this.notification.warning('Please enter Driver License Expired Date')
      return;
    }
    if (this.currentAddress.length < 1) {
      this.notification.warning('Please enter Current Address')
      return;
    }
    if (this.primaryContact.length < 9) {
      this.notification.warning('Please enter Primary Contact')
      return;
    }
    if (this.driverPicture == null) {
      this.notification.warning('Please select driver Picture')
      return;
    }
    if (this.nidPicture == null) {
      this.notification.warning('Please select NID Picture')
      return;
    }
    if (this.driveLicensePicture == null) {
      this.notification.warning('Please select Driver License Picture')
      return;
    }
    if (this.supportDocFiles.length === 0) {
      this.notification.warning('Please upload at least one Supported Document')
      return;
    }
    const driverData: any = {
      khmerName: this.khmerName,
      englishName: this.englishName,
      dateOfBirth: this.dateOfBirth ? formatDate(this.dateOfBirth, 'yyyy-MM-dd', 'en-US') : null,
      joinDate: this.joinDate ? formatDate(this.joinDate, 'yyyy-MM-dd', 'en-US') : null,
      nidNumber: this.NIDNumber,
      nidExpiryDate: formatDate(this.NIDExpiredDate, 'yyyy-MM-dd', 'en-US'),
      driverLicenseNumber: this.driverLicenseNumber,
      driverLicenseExpiryDate: formatDate(this.driverLicenseExpireDate, 'yyyy-MM-dd', 'en-US'),
      currentAddress: this.currentAddress,
      gender: this.selectedGender,
      maritalStatus: this.selectedMaritalStatus,
      primaryContactNumber: this.primaryContact,
      secondaryContactNumber: this.secondaryContact.join(','),
      emergencyContactNumber: this.emergencyContactNumber,
      isActive: 'true',
      nidPicture: this.nidPicture,
      driverLicensePicture: this.driveLicensePicture,
      picture: this.driverPicture,
      criminalRecordDocument: this.supportDocFiles[0] ?? this.criminalRecordPicture,
      supportDocuments: this.supportDocFiles
    };
    console.log('Submitting driver data:', driverData);

    let loginData = JSON.parse(localStorage.getItem('loginData')!)
    let endpoint = '';
    if (this.isEdit == 'true') {
      endpoint = '/api/drivers/' + this.editData["id"];
      this.apiService.putFormData(endpoint, driverData, loginData.token).subscribe({
        next: response => {
          console.log('HTTP Status:', response.status); // 👈 Get status here
          console.log('Response Body:', response.body);
          if (response.status === 200 || response.status === 201) {
            this.notification.success('Update Driver successfully');
          }
          else {
            this.notification.error('Update Driver failed. Please try again.');
          }
          this.location.back();
        },
        error: error => {
          console.error('Error:', error);
        }
      });
    }
    else {
      endpoint = '/api/drivers/register';
      this.apiService.postFormData(endpoint, driverData, loginData.token).subscribe({
        next: response => {
          console.log('HTTP Status:', response.status); // 👈 Get status here
          console.log('Response Body:', response.body);
          if (response.status === 200 || response.status === 201) {
            this.notification.success('Register Driver successfully');
          }
          else {
            this.notification.error('Register Driver failed. Please try again.');
          }
          this.location.back();
        },
        error: error => {
          console.error('Error:', error);
        }
      });
    }
  }

  ngOnDestroy() {
    if (this.loadingSubscription) {
      this.loadingSubscription.unsubscribe();
    }

    // Clean up blob URLs to prevent memory leaks
    this.imageUrlCache.forEach(url => URL.revokeObjectURL(url));
    this.imageUrlCache.clear();
  }
}
